(function () {
  var form = document.getElementById('FooterNewsletterForm');
  if (!form || !window.fetch) return;
  form.setAttribute('data-nocaptcha', 'true');

  var status = form.querySelector('[data-newsletter-status]');
  var emailInput = form.querySelector('input[name="contact[email]"]');
  var button = form.querySelector('button[type="submit"]');

  function clientId() {
    var key = 'portrait_client_id';
    var existing = window.localStorage.getItem(key);
    if (existing) return existing;
    var next = window.crypto && window.crypto.randomUUID
      ? window.crypto.randomUUID()
      : 'client-' + Date.now() + '-' + Math.random().toString(36).slice(2);
    window.localStorage.setItem(key, next);
    return next;
  }

  function setStatus(message, isError) {
    if (!status) return;
    status.textContent = message;
    status.classList.toggle('is-error', !!isError);
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    var apiBaseUrl = window.PORTRAIT_CONFIG && window.PORTRAIT_CONFIG.apiBaseUrl;
    if (!emailInput || !emailInput.value) {
      if (emailInput) emailInput.reportValidity();
      return;
    }
    if (!apiBaseUrl) {
      setStatus('Newsletter signup is temporarily unavailable. Please try again.', true);
      return;
    }

    button.disabled = true;
    setStatus('Subscribing...', false);

    fetch(apiBaseUrl.replace(/\/$/, '') + '/shopify/newsletter/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: emailInput.value, clientId: clientId() })
    })
      .then(function (response) {
        if (response.ok) return response.json();
        return response.json().catch(function () { return {}; }).then(function (body) {
          var error = new Error(body.message || 'Could not complete signup. Please try again.');
          error.status = response.status;
          throw error;
        });
      })
      .then(function () {
        setStatus('Thank you for subscribing.', false);
        emailInput.value = '';
      })
      .catch(function (error) {
        setStatus(error.message || 'Newsletter signup could not be completed. Please try again.', true);
      })
      .finally(function () {
        button.disabled = false;
      });
  }, true);
})();
